var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coreTech-module"},[_c('div',{staticClass:"coreTech-pic"},[_vm._t("coreTech-pic")],2),_vm._v(" "),_c('div',{staticClass:"coreTech-title"},[_vm._t("coreTech-title")],2),_vm._v(" "),_c('div',{staticClass:"coreTech-content"},[_vm._t("coreTech-content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a18f394","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/developer/plugins/CoreModule.vue
// module id = null
// module chunks = 